// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1wqrj","item":"PaymentsMobile_item__1MoC9","label":"PaymentsMobile_label__t0b52","amount":"PaymentsMobile_amount__3gU41"};